import PropTypes from 'prop-types';

import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

const TimeRangeRadios = ({ radio: { name, value, onChange, disabled } }) => {
  const { t } = useTransl();

  return (
    <RadioGroup name={name} value={value} onChange={onChange}>
      <Box display="flex" alignItems="center">
        <FormControlLabel
          value="any"
          control={<Radio color="primary" />}
          label={t('schedule.anyTime')}
          disabled={disabled}
        />
        <FormControlLabel
          value="range"
          control={<Radio color="primary" />}
          label={t('schedule.timeRange')}
          disabled={disabled}
        />
      </Box>
    </RadioGroup>
  );
};
TimeRangeRadios.propTypes = {
  radio: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
  }).isRequired,
};

export default TimeRangeRadios;
